exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.imputazioni .v-menu__content {\n    width: fit-content;\n    max-width: fit-content;\n}\n.imputazioni .v-messages,\n.imputazioni .v-text-field__details {\n    display: none;\n}\n.imputazioni .col-md-6,\n.imputazioni .col-md-3,\n.imputazioni .col-md-4,\n.imputazioni .col-md-2,\n.imputazioni .col-md-1 {\n    margin-bottom: 2px;\n    padding-bottom: 3px;\n    border-bottom: 1px solid #ccc;\n}\n.imputazioni .col-md-1,\n.imputazioni .totali .col-md-2 {\n    display: flex;\n    align-items: center;\n    align-content: center;\n}\n", ""]);

// exports
